import { canViewAdminRoute } from '@ApplicationWide/permissions/adminVisibility';
import { canViewNonAdminRoute } from '@ApplicationWide/permissions/index';

export const hasRequiredRoleForRoute = (route, user) =>
  !route.requiredRoles || route.requiredRoles.length === 0 || route.requiredRoles.includes(user.userRole.roleType);

export const hasAdminPermissionForRoute = (route, user, company) =>
  !route.area || !route.adminVisibilityPermission || canViewAdminRoute(route, user, company);

export const hasPermissionForRoute = (route, user, company) => {
  if (!route.area) {
    return true;
  }
  if (route.adminVisibilityPermission) {
    return canViewAdminRoute(route, user, company);
  }

  return canViewNonAdminRoute(route, user, company);
};
